<template>
  <div
    v-if="$t('PAYBILL_NUMBER')"
    class="paybill"
  >
    <slot>
      <h3 class="title">
        Paybill
      </h3>
    </slot>
    <a
      class="paybill-number"
      :href="`tel:${paybillNumberTel}`"
    >
      {{ $t('PAYBILL_NUMBER') }}
    </a>
  </div>
</template>

<script>
export default {
  computed: {
    // 用来 a 标签 tel 拨打电话的号码，自动拨号的时候，不能带入数字之外的字符，需要编码
    paybillNumberTel() {
      const PAYBILL_NUMBER = this.$t('PAYBILL_NUMBER')
      return PAYBILL_NUMBER && encodeURIComponent(PAYBILL_NUMBER)
    }
  }
}
</script>
